(function ($) {

	var addCustomFileInput = function ($field) {
		var $input = $field.find('input[type="file"]');
		var $flag = $field.find('.file-input').length;

		if (($input.length) && !$flag) {
			$field.addClass('gf-fileupload');

			var $label = $('<label></label>').attr('for', $input.attr('id'));
			$label.addClass('file-input');

			$('<span class="file-input__cta">Browse</span>').appendTo($label);
			$('<span class="file-input__info">No file selected</span>').appendTo($label);
			$input.after($label);

			$input.on('change', function (e) {
				var fileName = '';

				if (this.files && this.files.length > 1) {
					fileName = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length);
				} else if (e.target.value) {
					fileName = e.target.value.split('\\').pop();
				}

				if (fileName) {
					var fileNameTruncated = fileName.length > 12 ? '... ' + fileName.substr(fileName.length - 12) : fileName;
					$field.find('.file-input__info').html(fileNameTruncated);
				} else {
					$field.find('.file-input__info').html('No file selected');
				}
			});
		}
	};

	// AppendTo Button
	var appendButtonToGformFields = function ($button) {
		var $flag = $button.parent('.gfield').length;
		if (!$flag) {
			$button.appendTo($('.cta-section__form .gform_fields')).wrap('<li class="gfield gfield--auto"></li>');
		}

	};


	// Trigger on GF form render
	jQuery(document).on('gform_post_render', function () {
		$('.js-file-input').each(function () {
			addCustomFileInput($(this));
		});
		$('.cta-section__form .gform_button').each(function () {
			appendButtonToGformFields($(this));
		});
	});

	(function (jQuery) {
		jQuery.fn.deserialize = function (data) {
			var f = jQuery(this),
				map = {},
				find = function (selector) { return f.is("form") ? f.find(selector) : f.filter(selector); };
			//Get map of values
			jQuery.each(data.split("&"), function () {
				var nv = this.split("="),
					n = decodeURIComponent(nv[0]),
					v = nv.length > 1 ? decodeURIComponent(nv[1]) : null;
				if (!(n in map)) {
					map[n] = [];
				}
				map[n].push(v);
			})
			//Set values for all form elements in the data
			jQuery.each(map, function (n, v) {
				find("[name='" + n + "']").val(v);
			})
			//Clear all form elements not in form data
			find("input:text,select,textarea").each(function () {
				if (!(jQuery(this).attr("name") in map)) {
					jQuery(this).val("");
				}
			})
			find("input:checkbox:checked,input:radio:checked").each(function () {
				if (!(jQuery(this).attr("name") in map)) {
					this.checked = false;
				}
			})
			return this;
		};
	})(jQuery);

	var productsTableExpandHandler = function () {
		$('.products-table__expand').each(function () {
			var id = $(this).data('products-group-id');

			if (typeof id == 'undefined' || id == '') {
				return;
			}

			$(this).prev().find('td').css('border-bottom', '0'); // Remove border above expand

			$(this).on('click', function () {
				if ($(window).width() < 768) {
					var itemPosition = $(this).offset().top;
					TweenLite.to(window, 0.8, { scrollTo: { y: itemPosition, offsetY: 60 } }); // Offset should be sticky header height
				}

				$('[data-products-group-id="' + id + '"]').fadeIn(400);
				$(this).hide();

				if ($(window).width() < 768) {
					$(this).prev().find('td.products-table__certificates').css('border-bottom', '1px solid #f4f4f4');
				} else {
					$(this).prev().find('td:not(:first-child)').css('border-bottom', '1px solid #f4f4f4');
				}
			});
		});
	}

	var productsItemExpandHandler = function () {
		if ($(window).width() < 768) {
			$('.products-table tbody tr:not(.products-table__expand)').each(function () {
				$(this).find('[data-accordion-header]').on('click', function (e) {
					e.preventDefault();
					$(this).parent().toggleClass('opened');

					if ($(this).parent().hasClass('opened')) {
						var itemPosition = $(this).parent().offset().top;
						TweenLite.to(window, 0.8, { scrollTo: { y: itemPosition, offsetY: 60 } }); // Offset should be sticky header height
					}
				});
			});
		}
	}

	var productsMatchHeightHandler = function () {
		$('.products-table td[data-mh]').matchHeight({
			byRow: false
		});
	}

	var productsTableStickyHeaderHandler = function () {
		var $productsTableStickyHeader = $('.products-table--with-sticky-header');
		if ($productsTableStickyHeader.length > 0) {
			$productsTableStickyHeader.each(function () {
				var $self = $(this);
				var $el = $self.find('.products-table__header > tr');
				// Duplicate table header
				var $clone = $el.clone();
				// Add width to sticky header columns
				var $oldThs = $el.find('th');
				var $newThs = $clone.find('th');
				var i, l = $newThs.length;
				for (i = 0; i < l; i += 1) {
					$newThs.eq(i).css('width', $oldThs.eq(i).outerWidth(true));
				}
				var $stickyEl = $('<div class="products-table-sticky-header"><table></table></div>');
				$stickyEl.find('table').append($clone);
				$stickyEl.prependTo($self);
				// Hide sticky header and calculate top breakpoint
				var breakpointTop = $self.offset().top;
				var siteStickyHeaderHeight = 60;
				if ($(window).outerWidth() < 992) {
					breakpointTop = breakpointTop - siteStickyHeaderHeight;
				}
				var rowHeight = $self.find('> table > tbody > tr:not([data-products-group-id])').outerHeight();
				var expandRowHeight = $self.find('> table > tbody > .products-table__expand').outerHeight();
				var negativeRow = rowHeight;
				if ($self.find('> table > tbody > [data-products-group-id]').is(':last-child')) {
					negativeRow = rowHeight + expandRowHeight;
					if ($(window).outerWidth() < 992) {
						negativeRow = negativeRow - siteStickyHeaderHeight;
					}
				}

				$stickyEl.affix({
					offset: {
						top: breakpointTop,
						bottom: function () {
							return (this.bottom = $('body').height() - breakpointTop - $self.outerHeight() + negativeRow);
						}
					}
				});
			});
		}
	}

	productsTableExpandHandler();
	productsItemExpandHandler();
	productsTableStickyHeaderHandler();

	// Match height
	if ($('.logo-list').length) {
		$('.logo-list li').matchHeight({
			byRow: false
		});
	}

	// Tooltip list area tooltips initial
	if ($('.tooltip-list-area [data-toggle="tooltip"]').length) {
		if ($(window).width() > 768) {
			$('.tooltip-list-area [data-toggle="tooltip"]').tooltip({
				html: true,
				placement: 'auto left'
			});
		} else {
			$('.tooltip-list-area .js-popup').magnificPopup({
				type: 'image',
				closeOnContentClick: true,
				mainClass: 'mfp-img-mobile mfp-tooltip',
				image: {
					verticalFit: true
				}
			});
		}
	};

	// Generic popup
	if ($('.js-generic-popup').length) {
		$('.js-generic-popup').magnificPopup({
			type: 'image',
			closeOnContentClick: true,
			mainClass: 'mfp-img-mobile mfp-tooltip',
			image: {
				verticalFit: true
			}
		});
	}

	// Offcanvas
	var scrollTop = 0;

	$('.offcanvas-toggle').on('click', function (event) {
		event.preventDefault();
		if ($('body').hasClass('offcanvas-expanded')) {
			$('body').removeClass('offcanvas-expanded');
			$('body').scrollTop(scrollTop);

			if ($(window).width() < 992) {
				$('.offcanvas').fadeOut('fast');
			}
		} else {
			$('body').addClass('offcanvas-expanded');
			scrollTop = $('body').scrollTop();

			if ($(window).width() < 992) {
				$('.offcanvas').fadeIn('fast');
			}
		}
	});

	$('.offcanvas-overlay').on('click', function () {
		$('body').removeClass('offcanvas-expanded');
	});

	// Offcanvas dropdown mobile
	if ($('.offcanvas-content-mobile').length) {
		$('a').on('click', function () {
			if (!$(this).parent().hasClass('menu-item-has-children')) {
				$('body').removeClass('offcanvas-expanded');
				if ($(window).width() < 992) {
					$('.offcanvas').fadeOut('fast');
				}
			}
		});

		$('.menu-item-has-children').on('click', function (event) {
			$('.offcanvas-content-mobile .menu-item-has-children > ul').hide();
			$(this).children('ul').show();
			$('.offcanvas-content-mobile').css('transform', 'translateX(-100%)');
		});

		$('.menu-item-back').on('click', function (event) {
			event.stopPropagation();
			$(this).parent().fadeOut('400');
			$('.offcanvas-content-mobile').css('transform', 'translateX(0)');
		});
	}

	// Mega menu background
	if ($('.menu-item-has-mega-menu').length) {
		$('head').append('<style id="mega-menu-styles"></style>');

		$(window).on('resize', function () {
			var windowWidth = $(window).outerWidth(true);
			var windowWidthFix = windowWidth - 8; // Fix for scrollbar
			var negativeMargin = -(windowWidth - $('.container').outerWidth()) / 2; // Spacing around container

			$('#mega-menu-styles').html('.menu-item-has-mega-menu > ul:before { width: ' + windowWidthFix + 'px; left: ' + negativeMargin + 'px }');
		});

		$(window).trigger('resize');
	}

	// Hero nav
	if ($('.hero-nav').length) {
		$('.hero-nav-list__item').on('mouseenter', function () {
			// Update items width
			$(this).addClass('active');
			TweenLite.to($('.hero-nav-list__item'), 0.4, { width: 100 / 3 + '%' });
			TweenLite.to($('.hero-nav-list__item:not(.active)'), 0.4, { width: '25%' });
			TweenLite.to($(this), 0.4, { width: '50%' });

			// Pull the paragraph in
			TweenLite.to($(this).find('.hero-nav__inner'), 0.4, { transform: 'translateY(-' + $(this).find('.hero-nav-list__content').outerHeight(true) + 'px)' });

			// Title font-size change
			TweenLite.to($(this).find('h3'), 0.4, { scale: 1.6 });

			// Add transparency to inactive elements
			TweenLite.to($('.hero-nav-list__item:not(.active) .hero-nav__inner h3'), 0.4, { opacity: '0.5' });
			TweenLite.to($(this).find('svg, .hero-nav-list__content'), 0.4, { opacity: '1' });
			$('.hero-nav__content').addClass('fade-element');

			// Background image change
			TweenLite.to($('.hero-nav__bg').find('[data-item-number="' + $(this).attr('data-item-number') + '"]'), 0.4, { opacity: '1' });
		}).on('mouseleave', function () {
			// Reset items width
			$(this).removeClass('active');
			TweenLite.to($('.hero-nav-list__item'), 0.4, { width: '33.3333333%' });

			// Push the paragraph out
			TweenLite.to($(this).find('.hero-nav__inner'), 0.4, { transform: 'translateY(0)' });

			// Reset title font-size
			TweenLite.to($(this).find('h3'), 0.4, { scale: 1 });

			// Reset transparency from inactive elements
			TweenLite.to($('.hero-nav-list__item:not(.active) .hero-nav__inner h3'), 0.4, { opacity: '1' });
			TweenLite.to($(this).find('svg, .hero-nav-list__content'), 0.4, { opacity: '0' });
			$('.hero-nav__content').removeClass('fade-element');

			// Reset background image
			TweenLite.to($('.hero-nav__bg img'), 0.4, { opacity: '0' });
		});
	}

	// Adding link functionality to .hero-nav-list__item
	$('[data-href]').on('click', function (event) {
		var $self = $(this);
		if (!$(event.target).closest('a').length) {
			event.preventDefault();
			location.href = $self.attr('data-href');
			return false;
		}
	});

	// Forms
	$('.js-generic-select').each(function () {
		var placeholder = $(this).data('placeholder');
		$(this).select2({
			minimumResultsForSearch: Infinity,
			placeholder: placeholder
		});
	});

	// Custom select
	if ($('.custom-select').length) {
		var updateCustomSelectHeader = function ($select) {
			var $items = $('.custom-select__list li input[type="checkbox"]:checked', $select);
			var items = [];

			if (!$items.length) {
				items = [$select.attr('data-placeholder')];
				$select.removeClass('custom-select--checked');
			} else {
				items = $.map($items, function (el) {
					return $(el).closest('li').find('label').text();
				});
				$select.addClass('custom-select--checked');
			}

			$('.custom-select__header span', $select).text(items.join(', '));
		};

		$('.custom-select__header').on('click', function (event) {
			$(this).parent().toggleClass('custom-select--open');
		});

		$('.custom-select__list li input[type="checkbox"]').on('change', function () {
			updateCustomSelectHeader($(this).closest('.custom-select'));
		});

		$('.custom-select').on('click', function (event) {
			event.stopPropagation();
		});

		$(document).on('click', function () {
			$('.custom-select.custom-select--open').removeClass('custom-select--open');
		});
	}

	// Accordion table
	if ($('.accordion-table').length) {
		$('.accordion-table-header').on('click', function () {
			$(this).next('.accordion-table-content').slideToggle(400);
			$(this).closest('.accordion-table').toggleClass('opened');

			if ($(this).closest('.accordion-table').hasClass('opened')) {
				var itemPosition = $(this).offset().top;
				TweenLite.to(window, 0.8, { scrollTo: { y: itemPosition, offsetY: 60 } }); // Offset should be sticky header height
			}
		});

		if ($(window).width() < 992) {
			$('.accordion-table-content .mobile-header').on('click', function () {
				$(this).parent().toggleClass('opened');

				if ($(this).parent().hasClass('opened')) {
					var itemPosition = $(this).offset().top;
					TweenLite.to(window, 0.8, { scrollTo: { y: itemPosition, offsetY: 60 } }); // Offset should be sticky header height
				}
			});
		}

		$('.accordion-table').each(function () {
			var undividedItems = $(this).find('thead th:not(:first-child):not(:nth-last-child(-n+3))').length;
			$(this).find('thead th:not(:first-child):not(:nth-last-child(-n+3))').css('width', 'calc(52% / ' + undividedItems + ')');
		});
	}

	// Initial smooth scrolling
	if (
		window.location.hash &&
		window.location.hash.substring(0, 2) == '#!' &&
		window.location.hash.indexOf('action=') == -1
	) {
		var $initialTarget = $('#' + window.location.hash.replace('#!', ''));
		if ($initialTarget.length > 0) {
			$('html, body').animate({ scrollTop: $initialTarget.offset().top - 74 }, 1000);
		}
	}

	// Smooth anchor scrolling
	$('.product-hero .type-card-list a').on('click', function () {
		$('html,body').animate({
			scrollTop: $($(this).attr('href')).offset().top
		}, 1000);

		return false;
	});

	// Smooth scrolling
	var smoothScrollTargets = [
		'.hero-subheader__cta-box-inner a[href*="#"]:not([href="#"])',
		'.offcanvas-content-desktop a[href*="#"]:not([href="#"])',
		'.offcanvas-content-mobile a[href*="#"]:not([href="#"])',
		'.product-hero-extras a[href*="#"]:not([href="#"])'
	];

	$(smoothScrollTargets).each(function (index, element) {
		$(element).on('click', function () {
			if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
				var target = $(this.hash.replace('#!', '#'));
				target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
				if (target.length) {
					$('html, body').animate({ scrollTop: target.offset().top - 74 }, 1000);
					return false;
				}
			}
		});
	});

	// Hero subheader fade in
	$(window).load(function () {
		if ($('.hero-subheader--fade-in').length) {
			var $heroSubheaderContent = $('.hero-subheader--fade-in .hero-subheader__content');
			TweenLite.to($heroSubheaderContent.find('h1'), 0.8, { opacity: 1, y: 0 });
			TweenLite.to($heroSubheaderContent.find('p'), 0.8, { opacity: 1, y: 0, delay: 0.2 });
		}
	});

	// Oils filter
	if ($('form[name="filter"]').length > 0) {
		var currentOilFilterRequestExists = false;
		var currentOilFilterRequest = null;
		var forceFilterOils = function () {
			var form = $('form[name="filter"]');
			// var container = $(form.data('container'));
			$('.custom-select', form).each(function (index, element) {
				updateCustomSelectHeader($(this));
			});
			if (!currentOilFilterRequestExists) {
				form.deserialize(window.location.hash.replace('#!', '')).trigger('change');
			}
			$('.products-table__loader').fadeIn();
			// See header.php:8
			$('html').css('visibility', 'visible');
		}
		$('form[name="filter"]')
			.on('submit', function (event) {
				event.preventDefault();
				var $self = $(this);
				var $dataContainer = $($self.data('container'));
				currentOilFilterRequestExists = true;
				$dataContainer.css({ opacity: 0.1 });

				if (typeof $self.data('prevent-history') == 'undefined' || (typeof $self.data('prevent-history') == 'boolean' && $self.data('prevent-history') === false)) {
					window.location.hash = "#!" + $self.serialize();
				} else {
					$('.products-table__loader').fadeIn();
				}

				currentOilFilterRequest = $.ajax({
					url: $self.attr('action'),
					data: $self.serialize(),
					beforeSend: function () {
						if (currentOilFilterRequest != null) {
							currentOilFilterRequest.abort();
						}
					},
					success: function (response) {
						currentOilFilterRequestExists = false;
						$dataContainer.html(response.data);
						if (response.show_message) {
							$('.notification-bar__content').html(response.message);
							$('.notification-bar').slideDown();
						} else {
							$('.notification-bar__content').html('');
							$('.notification-bar').slideUp();
						}
						if ($('.products-table__loader').is(':visible')) {
							$('.products-table__loader').fadeOut(200, function () {
								$dataContainer.css({ opacity: 1 });
							});
						} else {
							$dataContainer.css({ opacity: 1 });
						}
						//$dataContainer.fadeTo(200, 1);
						productsTableExpandHandler();
						productsItemExpandHandler();
						productsMatchHeightHandler();
						setTimeout(function () {
							productsTableStickyHeaderHandler();
						}, 200);
					}
				});
			})
			.on('change', function () {
				$(this).trigger('submit');
			})
			;
		// Handle filter bar close intent
		if ($('.notification-bar__close').length > 0) {
			$('.notification-bar__close').on('click', function (event) {
				event.preventDefault();
				$('form[name="filter"]')[0].reset();
				$('form[name="filter"]').trigger('change');
			});
		}
		// Check if filter needs to be applied when page loads
		if (window.location.hash.indexOf('action=filter-oils') != -1) {
			forceFilterOils();
		}
		// Check if filter needs to be applied on click
		$(window).on('hashchange', function () {
			if (window.location.hash.indexOf('action=filter-oils') != -1) {
				forceFilterOils();
			}
		});
	}

	// Job type filter
	if ($('form[name="filter--job_type"]').length > 0) {
		$('form[name="filter--job_type"]')
			.on('change', function (event) {
				var currentSelection = $('select[name="job_type"]').val();
				if (currentSelection > 0) {
					$('div[data-item-role="career"]').not('[data-term-id="' + currentSelection + '"]').hide();
					$('div[data-item-role="career"]').filter('[data-term-id="' + currentSelection + '"]').show();
				} else {
					$('div[data-item-role="career"]').show();
				}
				if ($('div[data-item-role="career"]:visible').length == 0) {
					$('div[data-item-role="no_results_message"]').show();
				} else {
					$('div[data-item-role="no_results_message"]').hide();
				}
			})
			;
	}

	// Resources filter
	var $resourcesForm = $('form[name="filter-resources"]');
	var $resourcesLoadMoreButton = $('.resources-grid__load-more');

	if ($resourcesForm.length > 0) {
		var currentResourceFilterRequestExists = false;
		var currentResourceFilterRequest = null;
		var currentResourceFilterIsLoadMore = false;
		var currentResourceFilterPage = 1;
		var currentResourceFilterCount = $resourcesForm.data('count');
		var currentResourceFilterPostsPerPage = $resourcesForm.data('posts-per-page');

		var loadMoreButtonHandle = function () {
			if ($resourcesLoadMoreButton.length > 0) {
				if (currentResourceFilterCount <= (currentResourceFilterPostsPerPage * currentResourceFilterPage)) {
					$resourcesLoadMoreButton.hide();
				} else if (currentResourceFilterRequestExists) {
					$resourcesLoadMoreButton.hide();
				} else {
					$resourcesLoadMoreButton.show();
				}
			}
		}

		var forceFilterResources = function () {
			$('.custom-select', $resourcesForm).each(function (index, element) {
				updateCustomSelectHeader($(this));
			});
			if (!currentResourceFilterRequestExists) {
				$resourcesForm.deserialize(window.location.hash.replace('#!', '')).trigger('change');
			}
			$('.resources-grid__loader').fadeIn();
			// See header.php:8
			$('html').css('visibility', 'visible');
		}

		loadMoreButtonHandle();

		$resourcesForm.on('submit', function (event) {
			event.preventDefault();
			var $self = $(this);
			var $dataContainer = $($self.data('container'));

			currentResourceFilterRequestExists = true;
			$dataContainer.css({ opacity: 0.1 });
			loadMoreButtonHandle();

			if (typeof $self.data('prevent-history') == 'undefined' || (typeof $self.data('prevent-history') == 'boolean' && $self.data('prevent-history') === false)) {
				window.location.hash = "#!" + $self.serialize();
			} else {
				$('.resources-grid__loader').fadeIn();
			}

			currentResourceFilterRequest = $.ajax({
				url: $self.attr('action'),
				data: $self.serialize(),
				beforeSend: function () {
					if (currentResourceFilterRequest != null) {
						currentResourceFilterRequest.abort();
					}
				},
				success: function (response) {
					currentResourceFilterRequestExists = false;
					currentResourceFilterCount = response.count;
					currentResourceFilterPostsPerPage = response.posts_per_page;
					var $elements = $(response.data);

					if (currentResourceFilterIsLoadMore) {
						$dataContainer.append($elements);
						currentResourceFilterIsLoadMore = false;
						currentResourceFilterCount = response.count;
						$('body, html').animate({ scrollTop: $elements.offset().top }, 1000);
					} else {
						$dataContainer.html($elements);
					}

					
					loadMoreButtonHandle();

					if (response.show_message) {
						$('.notification-bar__content').html(response.message);
						$('.notification-bar').slideDown();
					} else {
						$('.notification-bar__content').html('');
						$('.notification-bar').slideUp();
					}
					if ($('.resources-grid__loader').is(':visible')) {
						$('.resources-grid__loader').fadeOut(200, function () {
							$dataContainer.css({ opacity: 1 });
						});
					} else {
						$dataContainer.css({ opacity: 1 });
					}


					$('#resources-grid').imagesLoaded( function() {
						$('#resources-grid .article-card').matchHeight();
					});
				}
			});
		})
			.on('change', function () {

				// Reset pagination value if is not load more change
				if (!currentResourceFilterIsLoadMore) {
					currentResourceFilterPage = 1;
				}

				// Apply pagination count to form input field
				$('form[name="filter-resources"] input[name="resources_page"]').val(currentResourceFilterPage);
				$(this).trigger('submit');
			});

		// Handle filter bar close intent
		if ($('.notification-bar__close').length > 0) {
			$('.notification-bar__close').on('click', function (event) {
				event.preventDefault();
				$resourcesForm[0].reset();
				$resourcesForm.trigger('change');
			});
		}

		// Handle resources load more
		if ($resourcesLoadMoreButton.length > 0) {
			$resourcesLoadMoreButton.on('click', function (event) {
				event.preventDefault();
				currentResourceFilterIsLoadMore = true;
				currentResourceFilterPage++;
				$resourcesForm.trigger('change');
			});
		}


		// Check if filter needs to be applied when page loads
		if (window.location.hash.indexOf('action=filter-resources') != -1) {
			forceFilterResources();
		}
		// Check if filter needs to be applied on click
		$(window).on('hashchange', function () {
			if (window.location.hash.indexOf('action=filter-resources') != -1) {
				forceFilterResources();
			}
		});
	}


	// Reveal animations
	var $revealElement = $('[data-reveal]');

	if ($revealElement.length > 0) {
		var checkIfInView = function () {
			$revealElement = $revealElement.not('.in-view');

			if (!$revealElement.length) {
				$(window).off('scroll.checkIfInView resize.checkIfInView');
				return;
			}

			var windowHeight = $(window).height();
			var windowPositionTop = $(window).scrollTop();
			var windowPositionBottom = windowPositionTop + windowHeight;

			$revealElement.each(function () {
				var $self = $(this);
				var elementHeight = $self.outerHeight();
				var elementPositionTop = $self.offset().top;
				var elementPositionBottom = elementHeight + elementPositionTop;

				if ((elementPositionBottom >= windowPositionTop) && (elementPositionTop <= windowPositionBottom)) {
					$self.addClass('in-view');
				}
			});
		}

		setTimeout(function () {
			$(window).on('scroll.checkIfInView resize.checkIfInView', checkIfInView);
			checkIfInView();
		}, 300);
	}

	// Lightbox gallery
	var $lightboxGallery = $('.lightbox-gallery');

	if ($lightboxGallery.length > 0) {
		$lightboxGallery.find('.btn').on('click', function () {
			$(this).parents('.lightbox-gallery').find('.lightbox-gallery__images').magnificPopup('open');
		});

		$lightboxGallery.find('.lightbox-gallery__images').each(function () {
			$(this).magnificPopup({
				delegate: 'li a',
				type: 'image',
				tLoading: 'Loading ...',
				gallery: {
					enabled: true,
					navigateByImgClick: true
				}
			});
		});
	}

	$('[role="alert"][data-alert-scope="global"][data-alert-id]').on('closed.bs.alert', function () {
		Cookies.set('catania_lgabid', $(this).data('alert-id'), { expires: 365, path: '/' });
	});

	$('[role="alert"][data-alert-scope="homepage"][data-alert-id]').on('closed.bs.alert', function () {
		Cookies.set('catania_lhabid', $(this).data('alert-id'), { expires: 365, path: '/' });
	});

	$('[role="alert"][data-alert-scope][data-alert-id]').each(function (i, notification) {
		if ($(this).data('alert-scope') === 'global') {
			if (Cookies.get('catania_lgabid') !== $(this).data('alert-id')) {
				$(this).slideDown();
			} else {
				$(this).remove();
			}
		} else if ($(this).data('alert-scope') === 'homepage') {
			if (Cookies.get('catania_lhabid') !== $(this).data('alert-id')) {
				$(this).slideDown();
			} else {
				$(this).remove();
			}
		}
	});

	(function () {
		var $numberInput = $('.js-number-input');
		var $totalPriceHelper = $('.js-total-price-helper');
		var hasTotalPriceHelperComponent = $totalPriceHelper.length > 0;
		var currencySymbol = (hasTotalPriceHelperComponent) ? $totalPriceHelper.data('currency-symbol') : '';
		var currencySymbolPosition = (hasTotalPriceHelperComponent) ? $totalPriceHelper.data('currency-symbol-position') : '';

		var handleTotalPriceHelper = function () {
			if (hasTotalPriceHelperComponent) {
				var $priceQuantityInputs = $('input[type="number"][data-price]');
				var newTotalSum = 0;

				$priceQuantityInputs.each(function () {
					newTotalSum += ($(this).data('price') * $(this).val());
				});

				var newTotalSumOut = (Math.round((newTotalSum + Number.EPSILON) * 100) / 100).toFixed(2);

				switch (currencySymbolPosition) {
					case 'left':
						newTotalSumOut = currencySymbol + newTotalSumOut;
						break;
					case 'right':
						newTotalSumOut = newTotalSumOut + currencySymbol;
						break;
					case 'left_space':
						newTotalSumOut = currencySymbol + " " + newTotalSumOut;
						break;
					case 'right_space':
						newTotalSumOut = newTotalSumOut + " " + currencySymbol;
						break;
					default:
						break;
				}

				$totalPriceHelper.html(newTotalSumOut);
			}
		}

		$numberInput.each(function () {
			var $wrapper = $(this);
			var $increase = $wrapper.find('.number-input__button--increase');
			var $decrease = $wrapper.find('.number-input__button--decrease');
			var $input = $wrapper.find('.number-input__input');

			$increase.on('click', function (event) {
				event.preventDefault();

				var value = Number($input.val());

				if (Number.isNaN(value) || !Number.isFinite(value)) {
					value = 0;
				}

				$input.val(value + 1).trigger('change');

				handleTotalPriceHelper();
			});

			$decrease.on('click', function (event) {
				event.preventDefault();

				var value = Number($input.val());

				if (Number.isNaN(value) || !Number.isFinite(value)) {
					value = 0;
				}

				$input.val(Math.max(0, value - 1)).trigger('change');

				handleTotalPriceHelper();
			});
		});
	})();

	// Featured products slider
	$('.js-featured-products-slider').slick({
		speed: 500,
		adaptiveHeight: true,
		autoplay: true,
		autoplaySpeed: 3000,
		arrows: true,
		slidesToShow: 3,
		slidesToScroll: 1,
		dots: false,
		responsive: [
			{
				breakpoint: 1400,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
					dots: true,
					arrows: false,
				}
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
					dots: true,
					arrows: false,
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					dots: true,
					arrows: false,
				}
			}
		],
	});

	// Resource Gated Handler

	var $resourceTy = $('.js-resource-ty');
	var $resourceArticle = $('.js-resource-article');
	var $resourceForm = $('.js-resource-form');
	var $resourceDescription = $('.js-resource-description');
	var $resourceButton = $('.js-resource-button');


	function resourceSetStep(step) {
		var currentStep = 0;

		if (step === 1) {
			$resourceForm.toggle();
			currentStep = 1;
		}

		if (step === 2) {

			if (currentStep === 1) {
				$resourceForm.toggle();
			}

			$resourceDescription.toggle();
			currentStep = 2;
		}

		if (step === 3) {
			$resourceArticle.toggle();
			$resourceTy.toggle();
			currentStep = 3;
		}
	}

	if ($resourceArticle.length > 0) {
		var isResourceGated = false;

		if ($resourceArticle.data('gated') === 1 && (Cookies.get('catania_resources_ungated') !== 'true')) {
			isResourceGated = true;
		}

		if (isResourceGated) {
			resourceSetStep(1);
		} else {
			resourceSetStep(2);
		}

		$(document).on("gform_confirmation_loaded", function (e, form_id) {
			Cookies.set('catania_resources_ungated', 'true', { expires: 365 });
			resourceSetStep(3);
		});
	}

	$('.js-featured-article-slider').slick({
		speed: 750,
		autoplay: true,
		autoplaySpeed: 5000,
		arrows: true,
		prevArrow: '<button type="button" class="slick-prev"><svg width="12" height="7" viewBox="0 0 12 7" xmlns="http://www.w3.org/2000/svg"><path d="M1.526 6.632a.896.896 0 01-1.265 0 .896.896 0 010-1.264L5.368.26a.896.896 0 011.264 0l5.107 5.107a.896.896 0 010 1.264.896.896 0 01-1.265 0L5.998 2.155 1.526 6.632z" fill="currentColor" fill-rule="evenodd"/></svg></button>',
		nextArrow: '<button type="button" class="slick-next"><svg width="12" height="7" viewBox="0 0 12 7" xmlns="http://www.w3.org/2000/svg"><path d="M1.526.261a.896.896 0 00-1.265 0 .896.896 0 000 1.265l5.107 5.106a.896.896 0 001.264 0l5.107-5.106a.896.896 0 000-1.265.896.896 0 00-1.265 0L5.998 4.738 1.526.261z" fill="currentColor" fill-rule="evenodd"/></svg></button>',
		dots: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		fade: true,
		rows: false,
		adaptiveHeight: true,
	});

	var waitForEl = function(selector, callback) {
		if ($(selector).length) {
		  callback();
		} else {
		  setTimeout(function() {
			waitForEl(selector, callback);
		  }, 100);
		}
	};

	waitForEl(".wps-btn-secondary", function() {
		var continueShoppingEl = document.querySelector('.wps_storefront_link');

		if (continueShoppingEl) {
			continueShoppingEl.classList.remove('hidden');
		}
	});

	if (wp && wp.hooks) {
		wp.hooks.addFilter(
			'before.productBuyButton',
			'shopwp',
			function (defaultValue, productState) {
				if (productState.selectedVariant) {
					return (
						'<div class="swp-variant-weight">Package weight: ' +
						productState.selectedVariant.weight +
						'lb</div>'
					)
				}
			}
		)
		wp.hooks.addFilter(
			'after.productPricing',
			'shopwp',
			function (defaultText, productState) {
				if (productState.selectedVariant && productState.selectedVariant.quantityAvailable < 10) {
					return (
						'<div class="swp-variant-left-in-stock">Only ' +
						productState.selectedVariant.quantityAvailable +
						' left in stock!</div>'
					)
				}
			}
		)
	};

	$(document).ready(function () {
		// Product slider
		$('.js-related-products-slider').each(function(index, element) {
			$(this).slick({
				slidesToShow: 2,
				slidesToScroll: 1,
				speed: 500,
				adaptiveHeight: true,
				infinite: false,
				arrows: true,
				nextArrow: $(element).parent().find('.slick-prev'),
				prevArrow: $(element).parent().find('.slick-next'),
				dots: true,
				appendDots: $(element).parent().find('.resource-slider-dots'),
				responsive: [
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 1
						}
					}
				]
			});
		});

		$('.js-related-resources-slider').each(function(index, element) {
			$(this).slick({
				slidesToShow: 3,
				slidesToScroll: 1,
				speed: 500,
				adaptiveHeight: true,
				infinite: false,
				dots: true,
				arrows: true,
				nextArrow: $(element).parent().find('.slick-prev'),
				prevArrow: $(element).parent().find('.slick-next'),
				appendDots: $(element).parent().find('.resource-slider-dots'),
				responsive: [
					{
						breakpoint: 1200,
						settings: {
						slidesToShow: 2,
						slidesToScroll: 1,
						}
					},
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
						}
					}
				]
			});
		});

		// Testimonial slider
		$('.js-testimonial-slider').slick({
			speed: 500,
			adaptiveHeight: true,
			autoplay: true,
			autoplaySpeed: 3000,
			arrows: false,
			dots: true,
		});

		$('.js-photo-carousel').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			centerMode: true,
			centerPadding: '25%',
			speed: 500,
			adaptiveHeight: true,
			infinite: true,
			dots: false,
			arrows: true,
			prevArrow: '#photo-carousel-prev',
			nextArrow: '#photo-carousel-next',
		});

		$('.js-causes').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			speed: 500,
			adaptiveHeight: true,
			infinite: true,
			dots: true,
			appendDots: '#causes-slider-dots',
			arrows: true,
			prevArrow: '#causes-slider-prev',
			nextArrow: '#causes-slider-next',
		});

		$('.js-faq-slider').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			speed: 500,
			adaptiveHeight: true,
			infinite: false,
			dots: true,
			appendDots: '#faq-slider-dots',
			arrows: false,
		});

		$('.js-pv-slider').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			speed: 500,
			adaptiveHeight: true,
			infinite: false,
			dots: true,
			appendDots: '#pv-slider-dots',
			arrows: false,
		});
	});

		

}(jQuery));
